import { call, put, takeLatest } from 'redux-saga/effects';
import { CorporateHealthClaim } from '@models/CorporateHealthClaim';
import { CorporateHealthClaimApi } from '@apis/CorporateHealthClaimApi';
import { corporateHealthClaimFetch, CorporateHealthClaimFetchPayload, stateUpdate, StateUpdatePayload } from './action';
import { SagaPayload } from '@utils/typescript';

function* handleCorporateHealthClaimFetch({ payload }: SagaPayload<CorporateHealthClaimFetchPayload>) {
  const state: StateUpdatePayload = { corporateHealthClaim: null };
  try {
    state.corporateHealthClaim = (yield call(CorporateHealthClaimApi.get, payload)) as CorporateHealthClaim;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(corporateHealthClaimFetch, handleCorporateHealthClaimFetch);
}
